import { render } from "./BoardingPlace.vue?vue&type=template&id=019e4b4c&scoped=true"
import script from "./BoardingPlace.vue?vue&type=script&lang=js"
export * from "./BoardingPlace.vue?vue&type=script&lang=js"

import "./BoardingPlace.vue?vue&type=style&index=0&id=019e4b4c&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019e4b4c"]])

export default __exports__